// Most frequent finite number in the list. Ties break to the smaller value.
// Non-numbers/NaN are ignored; returns null when there are no usable values.
export function mostFrequent(values: (number | null | undefined)[]): number | null {
  const counts = new Map<number, number>();
  for (const value of values) {
    if (typeof value !== 'number' || !Number.isFinite(value)) continue;
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  if (counts.size === 0) return null;
  return [...counts.entries()].reduce(
    (best, current) => (current[1] > best[1] || (current[1] === best[1] && current[0] < best[0]) ? current : best),
    [Number.POSITIVE_INFINITY, -1] as [number, number],
  )[0];
}

export function uniqueSortedStrings(values: string[]): string[] {
  // `numeric` makes embedded numerals sort by value ("5" < "10" < "100") rather
  // than lexically, while still ordering plain strings and dates correctly.
  return Array.from(new Set(values.filter(Boolean))).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
}
